import { cx } from '@fable/theme'

import { colors, layout } from './styles'

export const LegacyTheme: React.FC<{
  children?: React.ReactNode | string | null
}> = ({ children }) => {
  return <div className={cx(colors, layout, 'fds-ui--theme')}>{children}</div>
}
